import React from 'react';
import { Check, Flame, ShoppingCart, Clock } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-167">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-4 bg-gradient-to-r from-[#D4522A] via-[#F5A623] to-[#2D6A4F]" data-id="element-168"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="text-center mb-16" data-id="element-170">
          <span className="text-[#D4522A] font-bold tracking-widest uppercase text-sm" data-id="element-171">
            Presentando
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C1810] mt-2 mb-6" data-id="element-172">
            El Método{' '}
            <span className="text-[#2D6A4F]" data-id="element-173">"Cena de 7 Minutos"</span>
          </h2>
          <p className="font-body text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-174">
            Un sistema diseñado para "hackear" los supermercados americanos
            (Walmart, Target, Aldi) y convertirlos en tu aliado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-175">
          {/* Feature 1 */}
          <div className="bg-[#FDF6EC] p-8 rounded-2xl border-2 border-transparent hover:border-[#F5A623] transition duration-300" data-id="element-176">
            <div className="w-14 h-14 bg-[#F5A623] rounded-full flex items-center justify-center text-white mb-6 shadow-lg" data-id="element-177">
              <ShoppingCart className="w-7 h-7" data-id="element-178" />
            </div>
            <h3 className="font-heading text-2xl font-bold text-[#2C1810] mb-4" data-id="element-179">
              Sin Ingredientes Raros
            </h3>
            <p className="font-body text-gray-700" data-id="element-180">
              Olvídate de buscar "kale" o "quinoa" si no te gustan. Usamos lo
              que ya compras, pero con un giro estratégico.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-[#FDF6EC] p-8 rounded-2xl border-2 border-transparent hover:border-[#D4522A] transition duration-300" data-id="element-181">
            <div className="w-14 h-14 bg-[#D4522A] rounded-full flex items-center justify-center text-white mb-6 shadow-lg" data-id="element-182">
              <Flame className="w-7 h-7" data-id="element-183" />
            </div>
            <h3 className="font-heading text-2xl font-bold text-[#2C1810] mb-4" data-id="element-184">
              Sabor 100% Latino
            </h3>
            <p className="font-body text-gray-700" data-id="element-185">
              Recupera tu sazón sin la grasa. Aprende a cocinar rico sin sentir
              que estás "a dieta".
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-[#FDF6EC] p-8 rounded-2xl border-2 border-transparent hover:border-[#2D6A4F] transition duration-300" data-id="element-186">
            <div className="w-14 h-14 bg-[#2D6A4F] rounded-full flex items-center justify-center text-white mb-6 shadow-lg" data-id="element-187">
              <Clock className="w-7 h-7" data-id="element-188" />
            </div>
            <h3 className="font-heading text-2xl font-bold text-[#2C1810] mb-4" data-id="element-189">
              Listo en 7 Minutos
            </h3>
            <p className="font-body text-gray-700" data-id="element-190">
              Literalmente. Cronometrado. Entras a la cocina y sales con la cena
              lista antes de que termine una canción.
            </p>
          </div>
        </div>

        {/* Visual Break */}
        <div className="mt-16 bg-[#2C1810] rounded-3xl p-8 md:p-12 text-center text-white relative overflow-hidden" data-id="element-191">
          <div className="relative z-10" data-id="element-192">
            <h3 className="font-heading text-3xl font-bold mb-4" data-id="element-193">
              "No es tu falta de voluntad, es el pasillo 4 del supermercado."
            </h3>
            <p className="text-lg text-gray-300" data-id="element-194">
              Te enseñamos a navegar el supermercado para que la comida trabaje
              para ti, no en tu contra.
            </p>
          </div>
          <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/food.png')] opacity-10" data-id="element-195"></div>
        </div>
      </div>
    </section>;
}